/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The carrier-facing state of a pricing agreement. Maps from FreightSimple's
 * internal lifecycle: awaiting_pricing (we've asked the carrier to price a
 * customer), being_set_up (we're finalizing it), active (live), declined
 * (the carrier declined), cancelled, existing_customer (the carrier told us
 * this is already their direct customer).
 *
 * @export
 */
export const CustomerSpecificPricingStatus = {
  AwaitingPricing: "awaiting_pricing",
  BeingSetUp: "being_set_up",
  Active: "active",
  Declined: "declined",
  Cancelled: "cancelled",
  ExistingCustomer: "existing_customer",
} as const;
export type CustomerSpecificPricingStatus =
  (typeof CustomerSpecificPricingStatus)[keyof typeof CustomerSpecificPricingStatus];

export function instanceOfCustomerSpecificPricingStatus(value: any): boolean {
  for (const key in CustomerSpecificPricingStatus) {
    if (
      Object.prototype.hasOwnProperty.call(CustomerSpecificPricingStatus, key)
    ) {
      if (
        CustomerSpecificPricingStatus[
          key as keyof typeof CustomerSpecificPricingStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomerSpecificPricingStatusFromJSON(
  json: any,
): CustomerSpecificPricingStatus {
  return CustomerSpecificPricingStatusFromJSONTyped(json, false);
}

export function CustomerSpecificPricingStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingStatus {
  return json as CustomerSpecificPricingStatus;
}

export function CustomerSpecificPricingStatusToJSON(
  value?: CustomerSpecificPricingStatus | null,
): any {
  return value as any;
}

export function CustomerSpecificPricingStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingStatus {
  return value as CustomerSpecificPricingStatus;
}
